import { useTranslation } from 'react-i18next';

// Reused wherever we need a shipping address - the curator's own address here,
// and later each participant's address in the ship_split flow.
export const emptyAddress = {
  street: '',
  house_number: '',
  postal_code: '',
  city: '',
  country: '',
};

function AddressFields({ address, onChange }) {
  const { t } = useTranslation();

  function update(field, value) {
    onChange({ ...address, [field]: value });
  }

  return (
    <>
      <div className="field-row">
        <label className="field">
          {t('address.street')}
          <input value={address.street} onChange={(e) => update('street', e.target.value)} required />
        </label>
        <label className="field field-small">
          {t('address.houseNumber')}
          <input value={address.house_number} onChange={(e) => update('house_number', e.target.value)} required />
        </label>
      </div>

      <div className="field-row">
        <label className="field field-small">
          {t('address.postalCode')}
          <input value={address.postal_code} onChange={(e) => update('postal_code', e.target.value)} required />
        </label>
        <label className="field">
          {t('address.city')}
          <input value={address.city} onChange={(e) => update('city', e.target.value)} required />
        </label>
      </div>

      <label className="field">
        {t('address.country')}
        <input value={address.country} onChange={(e) => update('country', e.target.value)} required />
      </label>
    </>
  );
}

export default AddressFields;
